module.exports = __webpack_public_path__ + "img/logo.6d59925d.svg";